import * as yup from 'yup';
import { useSelector } from 'react-redux';
import { formatDollars } from '@wix/da-shared-react/pkg/utils/formatting';
import { getMaxPrice } from '@wix/da-shared-react/pkg/redux/shared/selectors';
import { FieldValidator } from '../../types';
import { TFunction } from 'react-i18next';

export const priceValidationSchema = (
  t: TFunction,
  maxPrice: number,
  inTier: boolean
) =>
  yup
    .number()
    .positive(t('deviationSubmit.validation.error.price.positive'))
    .integer(t('deviationSubmit.validation.error.price.integers'))
    .typeError(t('deviationSubmit.validation.error.type.number'))
    .test(
      'download-price',
      t('deviationSubmit.validation.error.price.invalid'),
      function (value) {
        let message;
        const valueStr = `${value}`;
        if (valueStr === '') {
          message = t('common.dollarPriceInput.validation.error.missingValue');
        } else if (isNaN(+valueStr)) {
          message = t('common.dollarPriceInput.validation.error.invalidValue');
        } else if (+valueStr < 1 || +valueStr > maxPrice) {
          message = t(
            inTier
              ? 'deviationSubmit.validation.error.price.invalid.updated.tier'
              : 'deviationSubmit.validation.error.price.invalid.updated',
            {
              min: formatDollars(1),
              max: formatDollars(maxPrice),
            }
          );
        }
        if (message) {
          return this.createError({ message });
        }
        return true;
      }
    );

export const rawValidator = (t: TFunction, maxPrice: number, inTier: boolean) =>
  yup.object({
    downloadDollarPrice: yup
      .number()
      .when(['isPurchasable', 'originalAttached'], {
        is: (isPurchasable, originalAttached) =>
          isPurchasable || originalAttached,
        then: () => priceValidationSchema(t, maxPrice, inTier),
      }),
  });

export const useValidation = (): FieldValidator => {
  const maxPrice: number = useSelector(getMaxPrice);

  return ({ params: { tierId }, initResponse }, t) => {
    const inTier = Boolean(tierId || initResponse.deviation?.primaryTier);
    return rawValidator(t, maxPrice, inTier);
  };
};
